import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen p-3">
      <div className="flex flex-column align-items-center justify-content-center w-full" style={{ maxWidth: "480px" }}>
        <Link to="/app/homepage">
          <img src="/images/logoosbuk.png" alt="OSBÜK Logo" className="mb-4" height="52" />
        </Link>
        <div className="w-full surface-card border-1 surface-border border-round-2xl shadow-3 py-5 px-4 sm:px-6 flex flex-column align-items-center text-center">
          <span className="text-blue-500 font-bold text-4xl mb-2">404</span>
          <h1 className="text-900 font-bold text-3xl mb-2">Sayfa Bulunamadı</h1>
          <p className="text-600 text-sm mb-4">Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
          <Link
            to="/app/homepage"
            className="w-full flex align-items-center p-3 border-round-xl surface-hover transition-colors text-left"
          >
            <span
              className="flex justify-content-center align-items-center bg-primary text-white border-round-lg flex-shrink-0"
              style={{ height: "3rem", width: "3rem" }}
            >
              <i className="pi pi-home text-xl"></i>
            </span>
            <span className="ml-3 flex flex-column">
              <span className="text-900 font-semibold mb-1">Ana Sayfa</span>
              <span className="text-600 text-sm">Ana sayfaya dönmek için tıklayınız</span>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
